export default __webpack_public_path__ + "static/media/apr2023-1.f359b76f.jpg";